import { r as i } from "./register-DUNcsiOT.js";
import { M as a } from "./register-DUNcsiOT.js";
const t = {
  dark: "minimal-icon-button--dark",
  light: "minimal-icon-button--light",
  "light-filled": "minimal-icon-button--light-filled"
}, o = {
  unset: "minimal-icon-button--size-unset",
  lg: "minimal-icon-button--lg",
  md: "minimal-icon-button--md",
  sm: "minimal-icon-button--sm",
  xs: "minimal-icon-button--xs"
};
i();
export {
  a as MinimalIconButton,
  o as SIZE,
  t as VARIANT
};
